import { getVersionsApi } from '@services/api/configuration';

const version = {
  versions: () => {
    return getVersionsApi()
      .getVersion()
      .then((elements) => elements);
  },
};
export default version;
